var initialize = require('./sv-jedesheim.initialize.js');
var events = require('./sv-jedesheim.events.js');
var auth = require('./sv-jedesheim.auth.js');
var validator = require('./sv-jedesheim.validator.js');

initialize.initializeSlider();
initialize.initializeElements();
events.registerCommonEvents();
auth.registerAuthEvents();
validator.validatorMethods();